import React from 'react';
import Select, { components } from 'react-select';
import { ICustomer, SelectValue } from 'src/types';
import { IconClient, Container } from './styles';

interface Props {
  customerList: ICustomer[];
  defaultCustomer?: ICustomer;
  label?: string;
  onSelect(customer: ICustomer): void;
  showAll?: boolean;
  width?: string;
  margin?: string;
  height?: string;
  align?: string;
  fontSize?: string;
}

const custom = {
  control: (styles: any, state: any) => ({
    ...styles,
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    borderRadius: 10,
    borderColor: state.selectProps.error ? 'red' : 'transparent',
    ':hover': {
      ...styles[':hover'],
      borderColor: state.selectProps.error ? 'red' : 'transparent',
      cursor: 'pointer',
    },
    padding: 5,
    fontSize: 16,
    color: '#333',
    boxShadow: '1px 2px 5px rgba(0, 0, 0, 0.15)',
    alignContent: 'center',
  }),
  option: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: state.isSelected ? '#333' : null,
    color: state.isSelected ? '#fff' : '#070606',
    ':active': {
      ...styles[':active'],
      backgroundColor: '#333',
      color: '#fff',
    },
  }),
  container: (styles: any) => ({
    ...styles,
    height: '100%',
  }),
};

const CustomerSelect: React.FC<Props> = ({
  customerList,
  onSelect,
  defaultCustomer,
  label,
  showAll,
  width,
  height,
  margin,
  align,
  fontSize,
}) => {
  const [options, setOptions] = React.useState<SelectValue[]>([]);

  const onChange = React.useCallback(
    (value: SelectValue | null) => {
      if (value) {
        const patient = customerList.find(
          (customer) => customer.customerId?.toString() === value.value,
        );
        if (patient) {
          onSelect(patient);
        } else {
          onSelect({} as ICustomer);
        }
      }
    },
    [onSelect, customerList],
  );

  React.useEffect(() => {
    const optionsList: SelectValue[] = [];

    if (showAll) optionsList.push({ label: 'Todos', value: '-1' });

    customerList.forEach((customer) => {
      const id = customer.customerId?.toString();
      optionsList.push({ value: id ?? '-1', label: customer.name });
    });
    setOptions(optionsList.concat());
  }, [customerList, showAll]);

  return (
    <Container width={width} heigth={height} alignContent={align} margin={margin}>
      <Select
        defaultValue={{
          value: defaultCustomer?.name || label || 'Selecione',
          label: defaultCustomer?.name || label || 'Selecione',
        }}
        options={options}
        onChange={onChange}
        styles={custom}
        components={{
          Control: ({ children, ...props }) => (
            <components.Control {...props}>
              <IconClient fontSize={fontSize} /> {children}
            </components.Control>
          ),
        }}
      />
    </Container>
  );
};

export default CustomerSelect;
